import { Spacer } from 'foundations-components/components/Spacer';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { StartsAtMicroCopy } from '../../../../components/merch-card/price-display/PriceStyledComponents';
import { SingleSkeletonLoader } from '../../../components/SingleSkeletonLoader';
import { usePerMonthPriceForTerm } from '../../../hooks/pricing/useGrowthPurchaseOptions';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { PriceByProductApiName } from '../../PriceByProductApiName';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MerchCardPrice = ({
  productApiName,
  showPerMonthPerSeat = false
}) => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const {
    discount,
    resolvedTerm,
    loading,
    error
  } = usePerMonthPriceForTerm({
    productApiName,
    term: queryParamTerm
  });
  if (loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  const hasDiscount = discount && discount > 0;
  const isAnnualPaymentTerm = resolvedTerm === 'ANNUAL';
  const showDiscountedCopy = hasDiscount || isAnnualPaymentTerm;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showDiscountedCopy ? StartsAtMicroCopy : /*#__PURE__*/_jsx(Spacer, {
      space: "600"
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-400",
      children: /*#__PURE__*/_jsx(PriceByProductApiName, {
        productApiName: productApiName,
        showPerMonthPerSeat: showPerMonthPerSeat
      })
    })]
  });
};